import { Divider, Input } from "antd5";
import { useState, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import HTML from "../common/HTML";
import { audit, openLinkInNewTab, getAllDemoDetails } from "../../actions";
import { SearchOutlined } from "@ant-design/icons";
import { analytics } from "firebase";
import CONFIG from "../../config";
import moment from "moment-timezone";
import { BasicModal } from "neo-latest";
import { getDisplayTime } from "../../utils/status";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Tag, Spin, Tooltip, Table, Icon, Form, Drawer, Popover, Row, Col } from 'antd';
import { roundToNearestHalf } from "../../utils/strings";
import DemoRegistrationModal from "../common/DemoRegistrationModal";
import { LoadingOutlined } from '@ant-design/icons';
import CapabilityRequestModal from "../common/CapabilityRequestModal";
import EZDemoFeedbackModal from "../common/EZDemoFeedbackModal";
import EZDemoReviews from "../ManageEZDemos/EZDemoReviews";
import DemoReviews from "../DemoSolutions/DemoReviews";
import { Icon as NeoIcon, Chip } from "@avaya/neo-react";
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const DemoCards = (props) => {
    const { items, fetchDemos } = props;
    const dispatch = useDispatch();
    const user = useSelector(({ user }) => user.profile);
    const isViewCommentEnabled = useSelector(({ user }) => user.isViewCommentEnabled);
    const isRatingEnabled = useSelector(({ user }) => user.isRatingEnabled);
    const isEzDemoRatingEnabled = useSelector(({ user }) => user.isEzDemoRatingEnabled);
    const isViewEzDemoCommentEnabled = useSelector(({ user }) => user.isViewEzDemoCommentEnabled);
    const timeZoneName = useSelector(({ user }) => user.profile ? user.profile.timezone : undefined);
    const [isDemoRegModalVisible, setIsDemoRegModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [feedbackState, setFeedbackState] = useState({
        showFeedbackModal: false,
        feedbackAuditId: null,
        currentViewedEZDemo: null
    });
    const [ezDemoReviews, setEzDemoReviewsState] = useState({
        reviewsVisible: false,
        currentItem: null,
        ezDemoId: null
    });

    const [showDCModal, setDCModal] = useState({
        modal: false,
        item: null
    })

    const [demoReviews, setDemoReviewsState] = useState({
        isVisible: false,
        demoId: null
    });

    const demoRef = useRef(null);
    const capabilityRef = useRef(null);

    const [searchTerm, setSearchTerm] = useState("");
    const filteredItems = useMemo(() => {
        if (!searchTerm) return items;
        const term = searchTerm.toLowerCase();
        return items.filter(item => {
            const haystack = [
                item.title,
                item.description,
                item.connectivityDetails
            ].filter(Boolean).join(" ").toLowerCase();
            return haystack.includes(term);
        });
    }, [items, searchTerm]);


    const limits = useMemo(
        () => Array.from({ length: items?.length }, (_, i) => (i % 3 === 1 ? 400 : 600)),
        [items]
    );

    const [modal, setModal] = useState({
        open: false,
        title: "",
        content: null,
    });

    const showModal = (item) => {
        setModal({
            open: true,
            title: item.title,
            content: item.content || "",
        });
    };

    const closeModal = () => setModal((m) => ({ ...m, open: false }));


    const handleEZDemoClick = async (ezDemo) => {
        let item = ezDemo?.ezDemo;
        item = { ...item, fileName: item?.isFile ? item.link?.match(CONFIG.regEx.getFileName)?.[0] : item?.link };
        const auditId = await dispatch(audit(ezDemo?.ezDemo?.id, ezDemo?.demo?.id, undefined));

        closeModal();

        setTimeout(() => {
            setFeedbackState(prev => ({
                ...prev,
                showFeedbackModal: true,
                feedbackAuditId: auditId,
                currentViewedEZDemo: item
            }));
        }, 3000)

        /* Firebase Analytics Log Event */
        const { demoGuide: {
            name: eventName,
            parameters: eventParams
        } } = CONFIG.firebaseEvents;
        let parameters = {};
        Object.keys(eventParams).forEach(paramKey => {
            parameters[paramKey] = item[eventParams[paramKey]]
        });
        analytics().logEvent(eventName, parameters);

        window.open(item.link, '_blank');
    }


    const renderEZDemos = (item) => {
        const ezDemos = item?.demoEzDemos || [];
        return ezDemos?.map((ezDemo) => {
            const tag = ezDemo?.ezDemo?.updatedTime === null
                ? `Created: ${moment.tz(ezDemo?.ezDemo?.createdTime, timeZoneName).format(CONFIG.dateFormats.userDateTime)}`
                : `Updated: ${moment.tz(ezDemo?.ezDemo?.updatedTime, timeZoneName).format(CONFIG.dateFormats.userDateTime)}`

            return (
                <div key={ezDemo?.ezDemo?.id} className='vertical-spacing horizontal-spacing'>
                    <div key={ezDemo?.ezDemo?.id} >
                        <div className="ez-demo">
                            <div style={{
                                fontSize: "14px", color: "#6DB5EC", display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}>
                                <div
                                    className="link"
                                    style={{ fontWeight: "600", fontFamily: 'Oxygen', textDecoration: "underline", color: "#004a82" }}
                                    onClick={() => handleEZDemoClick(ezDemo)}
                                >
                                    {ezDemo?.ezDemo?.title}
                                </div>
                                {isEzDemoRatingEnabled && <div>
                                    {ezDemo?.ezDemo?.ratingCount > 0 && <><span
                                        style={{
                                            fontSize: "10px",
                                            color: "#63C558",
                                            padding: "0 .4rem",
                                            borderRadius: 3,
                                            ...getRatingStyles(roundToNearestHalf(ezDemo?.ezDemo?.rating))
                                        }}
                                    >
                                        ★ {roundToNearestHalf(ezDemo?.ezDemo?.rating)}
                                    </span>
                                        {(ezDemo?.ezDemo?.ratingCount > 0 && isViewEzDemoCommentEnabled) && <span><Divider type="vertical" />
                                            <span
                                                style={{ fontSize: "12px", color: "#004a82" }}
                                                className="ant-rate-text link"
                                                onClick={() => {
                                                    if (isViewEzDemoCommentEnabled) {
                                                        setEzDemoReviewsState(prev => ({
                                                            ...prev,
                                                            reviewsVisible: true,
                                                            ezDemoId: ezDemo?.ezDemo?.id,
                                                            currentItem: ezDemo?.ezDemo
                                                        }));
                                                        closeModal();
                                                    }
                                                    else return null
                                                }}
                                            >
                                                {ezDemo?.ezDemo?.ratingCount} user ratings</span>
                                        </span>}
                                    </>
                                    }
                                </div>}
                            </div>
                            <div style={{ fontSize: "12px", color: "gray" }}>{tag}</div>
                        </div>

                        <div style={{ fontSize: "13px", color: "black", marginTop: "1rem" }}>
                            {ezDemo?.ezDemo?.description || null}
                        </div>
                    </div>
                    <Divider />
                </div >
            )
        })
    }

    const groupByCollateralType = (item) => {
        const { collaterals } = item || [];
        const timeZoneName = user ? user.timezone : "";
        let addedCollateralTypes = [];
        let collateralTypes = [];
        if (collaterals && collaterals?.length > 0) {
            collaterals.forEach(collateral => {
                let foundCollateralIndex = undefined;
                let newCollateral = {
                    id: collateral.id,
                    title: collateral.title,
                    link: collateral.link,
                    description: collateral.description,
                    tag: collateral.updatedTime === null
                        ? `Created: ${moment.tz(collateral.createdTime, timeZoneName).format(CONFIG.dateFormats.userDateTime)} `
                        : `Updated: ${moment.tz(collateral.updatedTime, timeZoneName).format(CONFIG.dateFormats.userDateTime)} `,
                    isNew: collateral.new,
                };
                if (!addedCollateralTypes.includes(collateral.collateralType.id)) {
                    addedCollateralTypes.push(collateral.collateralType.id);
                    collateralTypes.push({
                        id: collateral.collateralType.id,
                        name: collateral.collateralType.name,
                        collaterals: [newCollateral]
                    });
                }
                else {
                    foundCollateralIndex = collateralTypes.findIndex(collateralType => collateralType.id === collateral.collateralType.id);
                    collateralTypes[foundCollateralIndex].collaterals.push(newCollateral);
                }
            });
            return collateralTypes;
        }
        else return []
    }

    const handleLinkClick = (item) => {
        item = { ...item, fileName: item?.isFile ? item.link?.match(CONFIG.regEx.getFileName)?.[0] : item?.link }
        dispatch(audit(undefined, undefined, undefined, item?.id))
        /* Firebase Analytics Log Event */
        const { demoGuide: {
            name: eventName,
            parameters: eventParams
        } } = CONFIG.firebaseEvents;
        let parameters = {};
        Object.keys(eventParams).forEach(paramKey => {
            parameters[paramKey] = item[eventParams[paramKey]]
        });
        analytics().logEvent(eventName, parameters);
        window.open(item.link, '_blank');
    }

    const renderDownloadsList = (item) => {
        const downloads = groupByCollateralType(item);
        return downloads?.length > 0 && downloads?.map((collateralType, index) => {
            return (
                <div className='vertical-spacing horizontal-spacing'>
                    <div style={{ gap: "8px", display: "flex", flexDirection: "column" }}>

                        <div> <span className='demo-document-type oxygen-bold' style={{ fontSize: "15px", fontWeight: "600" }} >{collateralType?.name}</span></div>
                        {collateralType?.collaterals && collateralType?.collaterals?.length > 0 &&
                            collateralType?.collaterals?.map((collateral) => {
                                const dateString = collateral?.tag?.split(': ');
                                return (<div className='demo-document-div'>
                                    <div>
                                        <span className="link demo-document-title" style={{ color: "#004a82" }} onClick={() => handleLinkClick(collateral)}>{collateral.title}</span>
                                    </div>
                                    <div className='demo-document-date'>
                                        <span style={{ fontWeight: "500" }}>{dateString[0]}: </span><span style={{ fontWeight: "400" }}>{dateString[1]}</span>
                                    </div>
                                    <div style={{ marginTop: "0.5rem" }}>
                                        <span className='demo-document-description'>{collateral?.description}</span>
                                    </div>
                                </div>
                                )
                            })
                        }
                    </div>
                </div>
            );
        })
    }

    const getCurrentCapabilityStatus = (allCapabilityRequests, capability) => {
        let currentCapability = allCapabilityRequests?.find(item => item?.capability?.id === capability?.capability?.id);
        if (currentCapability && currentCapability?.capability?.id) return currentCapability;
        else return null
    }


    const renderCapabilitiesList = (item) => {
        const { demoCapabilities, capabilityRequests } = item;
        const columns = [
            {
                title: <span className='bold'>Title</span>,
                dataIndex: "capability",
                key: "title",
                align: "center",
                width: 200,
                render: (capability) => capability?.title
            },
            {
                title: <span className='bold'>Status</span>,
                key: "status",
                align: "center",
                width: 150,
                render: (capability) => {
                    let status = "-";
                    let tooltipMessage = "Your request was declined. Please refer to the declined email you received or refer to your notifications for further details and action."
                    if (capabilityRequests?.length > 0) {
                        let currentCapability = getCurrentCapabilityStatus(capabilityRequests, capability);
                        status = currentCapability?.status || "-"
                    }
                    return (status !== "-" ? <><Tag
                        color={CONFIG.capabilityRequestColors[status]}
                    >
                        {status}
                    </Tag>
                        <span>
                            {status === "Declined" && <>
                                <Tooltip className='capability-tooltip' title={tooltipMessage}>
                                    <Icon aria-label="aria-menu" type="info-circle" className="left-spacing-6 text-color-primary" />
                                </Tooltip>
                            </>
                            }
                        </span>
                    </> : <Tag color="blue" >No Request</Tag>)
                }
            },
            {
                title: <span className='bold'>Actions</span>,
                align: "center",
                width: 140,
                render: (capability) => {
                    const currentCapability = getCurrentCapabilityStatus(capabilityRequests, capability);
                    return (
                        <span>
                            {(currentCapability === undefined || currentCapability === null || currentCapability?.status === CONFIG.capabilityDetailsRequestStatus.Declined) ? <button className='link'
                                onClick={() => {
                                    capabilityRef.current = capability;
                                    setModalOpen(true);
                                    closeModal();
                                }}>
                                Request
                            </button> :
                                <span style={{ marginRight: "15px" }}>-</span>
                            }
                        </span>
                    )
                }

            },

        ];
        return (
            <div>
                <div style={{ paddingTop: "10px", fontSize: "12px" }}>
                    <span style={{ fontWeight: "600", fontFamily: 'Noto Sans', }}>Note: </span>
                    {CONFIG.capabilityMessage}
                </div>
                <br />
                {
                    <div
                        style={{ margin: "0px 10px 0px 0px", overflowX: "hidden", paddingBottom: "15px" }}>
                        <Table
                            columns={columns}
                            dataSource={demoCapabilities}
                            pagination={false}
                            size="small"
                            className='font'
                            scroll={{ x: "auto", y: "auto" }}
                        />
                    </div>
                }

            </div>
        )
    }

    const handleCancelCapabilityRequestModal = () => {
        setModalOpen(false);
        capabilityRef.current = null;
    }

    const handlePostEZDemoFeedbackSubmit = () => {
        setFeedbackState(prev => ({
            ...prev,
            showFeedbackModal: false,
            feedbackAuditId: null,
            currentViewedEZDemo: null
        }));
    }

    const buttonConfigs = [
        {
            label: "Access", onClick: (item) => {
                setModal({
                    open: true,
                    title: "Access",
                    content: <div> <div className="float-right" style={{ marginRight: "1rem" }}><button
                        onClick={async () => { dispatch(openLinkInNewTab(CONFIG.editComponentRoute.demoAccess.title + " " + item?.title, CONFIG.editComponentRoute.demoAccess.key + item?.id)) }}
                        style={{
                            fontSize: "11px",
                            padding: ".35rem .5rem",
                            border: "1px solid #2193D1",
                            borderRadius: 4,
                            background: "#fff",
                            cursor: "pointer",
                            color: "black",
                            fontFamily: "oxygen",
                        }}
                        className="primary-button-avaya"
                    >
                        View In Full Page
                    </button> </div><br /> <HTML htmlContent={item?.connectivityDetails || ""} /></div>,
                })
            },
            visible: (item) => !!item?.connectivityDetails,
        },
        {
            label: (item) => item?.showScheduleButton ? "Schedule Demo" : item?.showRequestButton ? "Request Demo" : item?.demoAlreadyRequested ? "Requested" : null, onClick: async (item) => {
                if (item?.showScheduleButton) {
                    dispatch(openLinkInNewTab(`Schedule Demo - ${item?.title}`, item?.demoType === CONFIG.demoTypes.standardDemo ? `/scheduler/standard/${item?.id}/new` : `/scheduler/lab/${item?.id}/new`))
                }
                else if (item?.showRequestButton) {
                    setLoading(true)
                    const demo = await getAllDemoDetails(item?.id);
                    demoRef.current = demo ? demo[0] : null;
                    setIsDemoRegModalVisible(true)
                    setLoading(false)
                }
                else if (item?.demoAlreadyRequested) return null
            }, disabled: (item) => item?.demoAlreadyRequested
        },
        {
            label: "Documents", onClick: async (item) => {
                setLoading(true);
                const demo = await getAllDemoDetails(item?.id);
                demoRef.current = demo ? demo[0] : null;
                setModal({
                    open: true,
                    title: "Documents",
                    content: renderDownloadsList(demoRef.current),
                })
                setLoading(false)
            },
            visible: (item) => !!item?.collateralsPresent,
        },
        {
            label: "EZ Demos", onClick: async (item) => {
                setLoading(true);
                const demo = await getAllDemoDetails(item?.id);
                demoRef.current = demo ? demo[0] : null;
                setModal({
                    open: true,
                    title: "EZ Demos",
                    content: renderEZDemos(demoRef.current),
                })
                setLoading(false)
            },
            visible: (item) => !!item?.demoEzDemosPresent,
        },
        {
            label: "Components",
            onClick: (item) => {
                setModal({
                    open: true,
                    title: "Components",
                    content: <HTML htmlContent={item?.componentDetails || ""} />,
                })
            },
            visible: (item) => !!item?.componentDetails,
        },
        {
            label: "Capability Requests", onClick: async (item) => {
                setLoading(true);
                const demo = await getAllDemoDetails(item?.id);
                demoRef.current = demo ? demo[0] : null;
                setModal({
                    open: true,
                    title: "Capability Requests",
                    content: renderCapabilitiesList(demoRef.current),
                })
                setLoading(false)
            }, visible: (item) => !!item?.capabilityRequestsPresent
        },
    ];

    const getRatingStyles = (r) => {
        if (r < 2.2) {
            return {
                backgroundColor: '#FFEBEE',
                color: '#ff0026'
            };
        }
        if (r < 3.8) {
            return {
                backgroundColor: '#FFF3E0',
                color: '#E65100'
            };
        }
        return {
            backgroundColor: '#E0F9DC',
            color: '#63C558'
        };
    };

    const renderDataCenters = (item) => {
        const timeZoneName = user ? user.timezone : "";
        const dataCenterStatus = item?.activeDataCenters?.flatMap((dc) =>
            dc?.active
                ? [
                    item?.demoDCStatuses?.find(
                        (s) => s?.dataCenter?.id === dc?.id
                    ) || { dataCenter: dc, description: null, status: CONFIG.demoStatus.default },
                ]
                : []
        ) || [];

        const userRegion = user.region?.name;

        // 2. Partition into green/yellow/red
        var availableGreenDataCenters = dataCenterStatus?.filter(dataCenter => dataCenter.status === CONFIG.demoStatus.dataCenterTypes.green);
        var availableYellowDataCenters = dataCenterStatus?.filter(dataCenter => dataCenter.status === CONFIG.demoStatus.dataCenterTypes.yellow);
        var unavailableDataCenters = dataCenterStatus?.filter(dataCenter => dataCenter.status === CONFIG.demoStatus.dataCenterTypes.red);
        // const showDivider = this.unavailableDataCenters?.length !== 0;
        // const availableDataCenters = [...this.availableGreenDataCenters, ...this.availableYellowDataCenters];
        let userRegionDataCenters = [];
        [...availableGreenDataCenters, ...availableYellowDataCenters, ...unavailableDataCenters].forEach(item => item.dataCenter?.regionsList?.forEach(region => {
            if (region.name === userRegion) userRegionDataCenters.push(item)
        }))
        return [
            renderMyRegionDataCenter(userRegionDataCenters, timeZoneName),
            <div>
                <div className='font' style={{ fontWeight: '600', width: "300px", fontFamily: 'Noto Sans', }}>All Data Centers</div><br />
                {[...availableGreenDataCenters, ...availableYellowDataCenters, ...unavailableDataCenters]?.length > 0 ? [...availableGreenDataCenters, ...availableYellowDataCenters, ...unavailableDataCenters]?.map((dataCenter, index) => {
                    return (
                        <div key={index} className='font'>
                            <Row className='font'>
                                <Col className='font' span={8}><span><Icon aria-label="aria-menu" type={CONFIG.demoStatus.icons[dataCenter.status]} className={CONFIG.demoStatus.colors[dataCenter.status]} /> &nbsp;&nbsp;&nbsp;{dataCenter.dataCenter.title}</span></Col>
                                <Col span={16} className={`data-center-status-desc ${dataCenter.description === null && "center-align font"}`}>{dataCenter.description !== null ? getDisplayTime(dataCenter.description, timeZoneName) : "-"}</Col>
                            </Row>
                            {/* {index === availableDataCenters?.length - 1 } */}
                        </div>
                    );
                }) : <div className='font' align="center"> No data centers available in any region</div>}
            </div>
        ]
    }

    const renderMyRegionDataCenter = (userRegionDataCenters, timeZoneName) => {
        return (
            <div>
                <div className='font' style={{ fontWeight: '600', fontFamily: 'Noto Sans', }}>My Region Data Center(s)</div><br />
                {userRegionDataCenters?.length > 0 ? userRegionDataCenters?.map((dataCenter, index) => {
                    return (
                        <div key={index}>
                            <Row className='font'>
                                <Col className='font' span={8}><span><Icon aria-label="aria-menu" type={CONFIG.demoStatus.icons[dataCenter.status]} className={CONFIG.demoStatus.colors[dataCenter.status]} /> &nbsp;&nbsp;&nbsp;{dataCenter.dataCenter.title}</span></Col>
                                <Col span={16} className={`data-center-status-desc ${dataCenter.description === null && "center-align"}`}>{dataCenter.description !== null ? getDisplayTime(dataCenter.description, timeZoneName) : "-"}</Col>
                            </Row>
                        </div>
                    );
                }) : <div className='font' align="center"> No data centers available in your region</div>}
                <Divider />
            </div>
        )
    }

    const renderStatusRow = (item) => {
        const dataCenterStatus = item?.activeDataCenters?.flatMap((dc) =>
            dc?.active
                ? [
                    item?.demoDCStatuses?.find(
                        (s) => s?.dataCenter?.id === dc?.id
                    ) || { dataCenter: dc, description: null, status: CONFIG.demoStatus.default },
                ]
                : []
        ) || [];

        const userRegion = user.region?.name;

        // 2. Partition into green/yellow/red
        var availableGreenDataCenters = dataCenterStatus?.filter(dataCenter => dataCenter.status === CONFIG.demoStatus.dataCenterTypes.green);
        var availableYellowDataCenters = dataCenterStatus?.filter(dataCenter => dataCenter.status === CONFIG.demoStatus.dataCenterTypes.yellow);
        let alertType = "error";
        let alertMessage = "Not Available";
        let status = 0;
        let tooltipMessage = "The demo is currently unavailable. Please hover over or click on the demo status for more information.";
        let isGreenDCStatus = true;
        let isYellowDCStatus = true;
        availableGreenDataCenters.forEach(item => isGreenDCStatus && item.dataCenter?.regionsList?.every((region) => {
            if (region.name === userRegion) {
                alertType = "success"
                alertMessage = "Available"
                isGreenDCStatus = false;
                status = 2;
                return false
            }
            else {
                alertType = "warning"
                alertMessage = "Available in other regions"
                status = 1
                tooltipMessage = "The demo is currently unavailable in your region but it is available in other regions. Please hover over or click on the demo status for more information."
            }
            return -1
        }))

        if (alertType !== "success") {
            availableYellowDataCenters.forEach(item => isYellowDCStatus && item.dataCenter?.regionsList?.every(region => {
                let otherYellowRegionCount = 0;
                otherYellowRegionCount = region.name !== userRegion ? otherYellowRegionCount + 1 : otherYellowRegionCount
                if (region.name === userRegion) {
                    alertType = "warning"
                    alertMessage = "Available"
                    if (otherYellowRegionCount === 0 && availableGreenDataCenters?.length === 0) {
                        tooltipMessage = "Some of the demo features might not be available. Please hover over or click on the demo status for more information."
                    }
                    else tooltipMessage = "Some of the demo features might not be available in your region. Please hover over or click on the demo status for more information."
                    isYellowDCStatus = false;
                    status = 1;
                    return false;
                }
                else {
                    alertType = "warning"
                    alertMessage = "Available in other regions"
                    status = 1;
                    tooltipMessage = "The demo is currently unavailable in your region but it is available in other regions. Please hover over or click on the demo status for more information."
                }
                return -1
            }))
        }

        return (
            <div className="demo-status-row font" style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <Popover placement="left" content={renderDataCenters(item)} id="solution-demo-card-status" >
                    <span onClick={() => dataCenterStatus?.length !== 0 && setDCModal(prev => ({
                        ...prev,
                        modal: true,
                        item: item
                    }))}>
                        <Tag className={`${CONFIG.demoStatus.tagColors[status].toLowerCase()}-tag`} style={{ display: "flex", gap: "4px", cursor: "pointer" }}>
                            <NeoIcon
                                aria-label="demo-status-icon"
                                className={`${CONFIG.demoStatus.tagColors[status].toLowerCase()}-tag-color`}
                                size="sm"
                                style={{ display: 'flex', alignItems: 'center' }}
                                icon={CONFIG.demoStatus.tagIcons[status]}
                            />
                            <span>{alertMessage}</span>
                        </Tag>
                    </span>
                </Popover>

                {alertType !== "success" && <>
                    <Tooltip title={tooltipMessage}>
                        <Icon aria-label="aria-menu" type="info-circle" className="text-color-primary" />
                    </Tooltip>
                </>
                }
            </div>
        );
    }

    return (
        <Spin spinning={loading} indicator={antIcon} >
            <div className="float-right" style={{ width: '33%', position: 'relative', top: "-1.5rem" }}>
                <Input
                    className='input-antd search-demo-card' size='medium'
                    placeholder="Search demos by title, description or access…"
                    allowClear
                    value={searchTerm}
                    prefix={<SearchOutlined />}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ marginBottom: 16 }}
                />
            </div>
            <div style={{ paddingBottom: '12rem' }}>
                {
                    (filteredItems && filteredItems?.length > 0) ? <ResponsiveMasonry
                        columnsCountBreakPoints={{ 0: 3 }}
                        gutter="24px"
                    >
                        <Masonry sequential={true}>
                            {filteredItems?.map((item, idx) => {
                                const full = item?.description || "";
                                const limit = limits[idx];
                                const isLong = full.length > limit;
                                const preview = isLong ? full.slice(0, limit) : full;
                                return (
                                    <article
                                        key={`${item?.id}-${idx}`}
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            borderRadius: 5,
                                            background: "#fff",
                                            padding: "1rem",
                                            boxShadow: "0 1px 3px rgba(0,0,0,.05)",
                                        }}

                                        className="columns-item"
                                    >
                                        <header
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                marginBottom: ".5rem",
                                            }}
                                        >
                                            <div className="oxygen-bold" style={{ margin: 0, fontSize: "14px", color: "#343434" }}>{item.title}</div>
                                            {item?.isNew && <span className='float-right'>
                                                <Chip variant="info" style={{ fontWeight: "400", fontSize: "11px", fontFamily: 'Noto Sans JP', display: "flex" }} >New</Chip>
                                            </span>}
                                        </header>

                                        <div style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            marginBottom: "8px"
                                        }}>
                                            {item?.demoType === CONFIG.demoTypes.standardDemo && <div>
                                                {renderStatusRow(item)}
                                            </div>}
                                            <div>
                                                {(item?.rating > 0 && isRatingEnabled) && <span
                                                    style={{
                                                        fontSize: "11px",
                                                        color: "#63C558",
                                                        padding: "0 .4rem",
                                                        cursor: isRatingEnabled ? "pointer" : "auto",
                                                        borderRadius: 3,
                                                        ...getRatingStyles(item.rating)
                                                    }}
                                                    onClick={() => {
                                                        if (isViewCommentEnabled) {
                                                            setDemoReviewsState(prev => ({
                                                                ...prev,
                                                                isVisible: true,
                                                                demoId: item?.id,
                                                            }))
                                                        }
                                                        else return null
                                                    }
                                                    }
                                                >
                                                    ★ {item?.rating?.toFixed(1)}
                                                </span>}
                                            </div>
                                        </div>



                                        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                                            {item?.solutions?.map((s) => (
                                                <span
                                                    key={s?.id}
                                                    style={{
                                                        fontSize: "10px",
                                                        background: "#D2F5FF",
                                                        color: "#0194D7",
                                                        padding: "0.25rem",
                                                        fontWeight: "500",
                                                        borderRadius: '2px',
                                                    }}
                                                >
                                                    {s?.title}
                                                </span>
                                            ))}
                                        </div>

                                        <Divider style={{ margin: "12px 0" }} />

                                        {
                                            item?.description !== null && <div style={{ margin: "0.5rem", color: "#666666", fontSize: "12px" }}>
                                                <HTML className="font" htmlContent={
                                                    isLong ? preview + "…" : preview
                                                } />
                                                {isLong && (
                                                    <button
                                                        onClick={() => showModal({ ...item, title: "Description", content: <HTML htmlContent={item?.description} /> })}
                                                        style={{
                                                            border: "none",
                                                            background: "none",
                                                            color: "#2193D1",
                                                            cursor: "pointer",
                                                            fontSize: "12px",
                                                            padding: 0,
                                                            marginLeft: "0.25rem",
                                                        }}
                                                    >
                                                        Read more
                                                    </button>
                                                )}
                                            </div>
                                        }

                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(3, 1fr)",
                                                gap: 6,
                                            }}
                                        >
                                            {buttonConfigs
                                                ?.filter(({ visible }) => !visible || visible(item))
                                                ?.map(({ label, onClick, disabled }) => {
                                                    const labelValue = typeof label === "function" ? label(item) : label;
                                                    const disabledValue = typeof disabled === "function" ? disabled(item) : disabled;

                                                    if (!labelValue) return null;
                                                    return (
                                                        <button
                                                            key={labelValue}
                                                            onClick={() => onClick(item)}
                                                            style={{
                                                                fontSize: "11px",
                                                                padding: ".35rem .5rem",
                                                                border: "1px solid #2193D1",
                                                                borderRadius: 4,
                                                                background: "#fff",
                                                                cursor: "pointer",
                                                                color: "black"
                                                            }}
                                                            disabled={disabledValue}
                                                            className="secondary-button-neo"
                                                        >
                                                            {labelValue}
                                                        </button>
                                                    )
                                                })}

                                        </div>
                                    </article>
                                )
                            })
                            }
                        </Masonry>
                    </ResponsiveMasonry>
                        :
                        <div style={{ paddingTop: "5rem" }}>
                            <div style={{ height: "150px" }} className='dashboard-no-schedules'><NeoIcon aria-label="menu-aria" icon="info" size='md' /> No demos match “{searchTerm}”
                            </div>
                        </div>
                }


                <BasicModal open={modal.open}
                    onClose={closeModal}
                    closeButtonLabel={"Close"}
                    title={modal.title}
                    className="neo-modal conflicting-modal-2 demo-cards-modal">
                    <div style={{ maxHeight: "450px", overflowY: "scroll", margin: "0.5rem" }} >
                        {modal.content}
                    </div>
                </BasicModal>

                {
                    isDemoRegModalVisible &&
                    <DemoRegistrationModal
                        visible={isDemoRegModalVisible}
                        handleDemoRequestSubmit={() => { setIsDemoRegModalVisible(false); demoRef.current = null; fetchDemos(); }}
                        demo={demoRef?.current}
                        isEdit={false}
                        handleCancel={() => { setIsDemoRegModalVisible(false); demoRef.current = null; }}
                    />
                }
                {modalOpen && <CapabilityRequestModal
                    data={capabilityRef?.current?.capability}
                    visible={modalOpen}
                    handleCancel={() => handleCancelCapabilityRequestModal()}
                    isEdit={false}
                    demo={demoRef?.current}
                    handlePostFeedbackSubmit={() => { handleCancelCapabilityRequestModal(); fetchDemos(); }}
                />}
                {feedbackState.showFeedbackModal && <EZDemoFeedbackModal
                    showFeedbackModal={feedbackState.showFeedbackModal}
                    feedbackAuditId={feedbackState.feedbackAuditId}
                    title={feedbackState.currentViewedEZDemo?.title}
                    handleCancel={() => {
                        setFeedbackState(prev => ({
                            ...prev,
                            showFeedbackModal: false,
                            feedbackAuditId: null,
                            currentViewedEZDemo: null
                        }));
                    }}
                    handlePostFeedbackSubmitOnDemoCard={handlePostEZDemoFeedbackSubmit}
                />}
                {ezDemoReviews.reviewsVisible && <Drawer
                    width="50%"
                    placement="right"
                    className="ez-demo-review-drawer"
                    title={"EZ Demo Reviews - " + ezDemoReviews?.currentItem?.title}
                    headerStyle={{ padding: '20px' }}
                    visible={ezDemoReviews.reviewsVisible}
                    onClose={() => setEzDemoReviewsState(prev => ({
                        ...prev,
                        reviewsVisible: false,
                        ezDemoId: null,
                        currentItem: null
                    }))}
                    closable={true}
                > <EZDemoReviews
                        ezDemoId={ezDemoReviews?.ezDemoId}
                        updateUserReviews={null}
                    />
                </Drawer>}
                {demoReviews.isVisible && <Drawer
                    width="50%"
                    placement="right"
                    className="ez-demo-review-drawer"
                    bodyStyle={{ margin: "1rem" }}
                    title={"Demo Reviews"}
                    headerStyle={{ padding: '20px' }}
                    visible={demoReviews.isVisible}
                    onClose={() => setDemoReviewsState(prev => ({
                        ...prev,
                        isVisible: false,
                        demoId: null,
                    }))}
                    closable={true}
                > <DemoReviews
                        reviewDemoId={demoReviews?.demoId}
                        isRatingRedirect={false}
                        scheduleId={null}
                        demoId={demoReviews?.demoId}
                        isLowRatingAlert={false}
                    />
                </Drawer>}
                <BasicModal
                    open={showDCModal.modal}
                    title="Datacenter Status"
                    className="neo-modal conflicting-modal-2 demo-cards-modal"
                    closeButtonLabel={"Close"}
                    onClose={() =>
                        setDCModal(prev => ({
                            ...prev,
                            modal: false,
                            item: null
                        }))
                    }

                >
                    {renderDataCenters(showDCModal.item)}
                </BasicModal>
            </div >
        </Spin >
    );
}

const DemoCardsRef = Form.create()(DemoCards);


export default DemoCardsRef;